import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import * as React from 'react';

import { Content } from 'components/AdminMain/Content';
import { Header } from 'components/AdminMain/Header';
import { muiTheme } from 'styles';

import { contentBoxStyle, mainBoxStyle, restBoxStyle } from './AdminMain.style';

const AdminMain = () => {
  return (
    <ThemeProvider theme={muiTheme}>
      <Box sx={mainBoxStyle}>
        <CssBaseline />

        <Box sx={restBoxStyle}>
          <Header />

          <Box component="main" sx={contentBoxStyle}>
            <Content />
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default AdminMain;
